// extracted by mini-css-extract-plugin
export default {"root":"LayoutLandingPage_root__skVrz","topbar":"LayoutLandingPage_topbar__58jx0","main":"LayoutLandingPage_main__GIvjs"};